import PropTypes from "prop-types";
import React from "react";
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form } from "reactstrap";
//redux
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
// action
import { userForgetPassword } from "../../slices/thunks";
// import images
// import profile from "../../assets/images/bg.png";
import logoLight from "../../assets/images/logo-light.svg";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { createSelector } from "reselect";

/**
* ForgetPasswordPage component responsible for handling the "Forgot Password" functionality.
* This component includes a form for users to enter their email, and upon submission,
* it dispatches an action to send a reset link to the provided email.
*
* @component
* @param {Object} props - The component props.
* @param {Object} props.history - The history object from React Router.
*/
const ForgetPasswordPage = props => {
	const dispatch = useDispatch();

	const validation = useFormik({
		// enableReinitialize : use this flag when initial values needs to be changed
		enableReinitialize: true,

		initialValues: {
			// email: "test@test.com",
			email: "",
		},
		validationSchema: Yup.object({
			email: Yup.string().required("Please Enter Your Email"),
		}),
		onSubmit: (values) => {
			dispatch(userForgetPassword(values, props.router.navigate));
		}
	});

	const selectLayoutProperties = createSelector(
		(state) => state.ForgetPassword,
		(state) => ({
			forgetError: state.forgetError,
			forgetSuccessMsg: state.forgetSuccessMsg,
		})
	);

	// Inside your component
	const {
		forgetError, forgetSuccessMsg
	} = useSelector(selectLayoutProperties);

	document.title = "Reset Password | Adcropper";
	return (
		<ParticlesAuth>
			<div className="auth-page-content mt-lg-5 mt-xs-5">

				<Container>
					<Row>
						<Col lg={12}>
							<div className="text-center mt-sm-5 mb-4 text-white-50">
								<div>
									<Link to="/" className="d-inline-block auth-logo">
										<img src={logoLight} alt="" height="40" />
									</Link>
								</div>
							</div>
						</Col>
					</Row>

					<Row className="justify-content-center">
						<Col md={8} lg={6} xl={5}>
							<Card className="mt-4">

								<CardBody className="p-4">
									<div className="text-center mt-2">
										<h5 className="text-primary">Forgot Password?</h5>
										<p className="text-muted">Reset password with Adcropper</p>

										<lord-icon
											src="https://cdn.lordicon.com/rhvddzym.json"
											trigger="loop"
											colors="primary:#0ab39c"
											className="avatar-xl"
											style={{ width: "120px", height: "120px" }}
										>
										</lord-icon>

									</div>
									{forgetError ?
										<Alert className="border-0 fs-12 mb-2 mx-2" color="danger">
											{forgetError}
										</Alert> :
										forgetSuccessMsg ?
											<Alert className="border-0 fs-12 mb-2 mx-2" color="success">
												{forgetSuccessMsg}
											</Alert> :
											<Alert className="border-0 alert-warning text-center fs-12 mb-2 mx-2" role="alert">
												Enter your email and instructions will be sent to you!
											</Alert>
									}
									<div className="p-2">
										<Form
											onSubmit={(e) => {
												e.preventDefault();
												validation.handleSubmit();
												return false;
											}}
										>
											<div className="mb-4">
												<Label className="form-label">Email</Label>
												<Input
													name="email"
													className="form-control"
													placeholder="Enter email"
													type="email"
													onChange={validation.handleChange}
													onBlur={validation.handleBlur}
													value={validation.values.email || ""}
													invalid={
														validation.touched.email && validation.errors.email ? true : false
													}
												/>
												{validation.touched.email && validation.errors.email ? (
													<FormFeedback type="invalid"><div>{validation.errors.email}</div></FormFeedback>
												) : null}
											</div>

											<div className="text-center mt-4">
												<button className="btn btn-success w-100" type="submit">Send Reset Link</button>
											</div>
										</Form>
									</div>
								</CardBody>
							</Card>

							<div className="mt-4 text-center">
								<p className="mb-0">Wait, I remember my password... <Link to="/login" className="fw-semibold link-danger text-decoration-underline"> Click here </Link> </p>
							</div>

						</Col>
					</Row>
				</Container>
			</div>
		</ParticlesAuth>
	);
};

ForgetPasswordPage.propTypes = {
	history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
